import React from 'react';
import styled from 'styled-components';

const Select = styled.select`
  max-width: 200px;
  flex: 1;
  padding: 10px;
  border: 1px solid ${({ theme }) => theme.colors.inputLine};
  background-color: ${({ theme }) => theme.colors.inputBG};
  border-radius: 6px;
  font-size: 14px;

  &:focus {
    outline: none;
    border-color: ${({ theme }) => theme.colors.mainColor};
  }
`;

interface SelectBoxProps {
  options: { value: string; label: string }[];
  value: string;
  onChange: (value: string) => void;
  placeholder?: string;
}

const SelectBox: React.FC<SelectBoxProps> = ({
  options,
  value,
  onChange,
  placeholder,
}) => {
  return (
    <div>
      <Select value={value} onChange={(e) => onChange(e.target.value)}>
        {placeholder && <option value="">{placeholder}</option>}
        {options.map((option, index) => (
          <option key={index} value={option.value}>
            {option.label}
          </option>
        ))}
      </Select>
    </div>
  );
};

export default SelectBox;
